import { Helmet, HelmetProvider } from "@dr.pogodin/react-helmet";

const PageMeta = ({
  title,
  description,
}: {
  title: string;
  /** Optional; defaults to a page-specific sentence for SEO / Lighthouse. */
  description?: string;
}) => {
  const appName = import.meta.env.VITE_APP_NAME || "TovRide";
  const pageTitle = `${appName} | ${title}`;
  const metaDescription =
    description?.trim() ||
    `${title}. Manage rides, drivers, vehicles, and operations in the ${appName} admin dashboard.`;
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
